import React from 'react';
import { Heart } from 'lucide-react';

const HeartLoader = () => {
    return (
        <div data-testid="heart-loader" className="heart-loader-wrapper">
            <div data-testid="heart-loader-container" className="heart-loader">
                <Heart data-testid="heart-icon" className="heart-icon" />
                <div data-testid="loading-animation" className="loading">
                    <svg data-testid="heart-svg" width="40px" height="24px">
                        <polyline
                            data-testid="heart-back-line"
                            points="0.157 11.977, 8 11.977, 11.922 2, 19.5 20, 26 5, 30 12, 340 12"
                            id="heart-back"
                        />
                        <polyline
                            data-testid="heart-front-line"
                            points="0.157 11.977, 8 11.977, 11.922 2, 19.5 20, 26 5, 30 12, 340 12"
                            id="heart-front"
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default HeartLoader;
